import { defineStore } from '@/utils/store'

export type StorageState = {
  login?: {
    account: string
    password: string
  }
}

/** 存放 localStorage */
export const [useStorageStore, setStorageState] = defineStore<StorageState>(
  {},
  {
    name: 'STORAGE',
  },
)

/** 刪除指定的 storage key */
export const deleteStorageItem = (key: string) => {
  try {
    window?.localStorage?.removeItem(key.toUpperCase())
  } catch {
    // ignore
  }
}

/** 取得 storage item */
export const getStorageItem = <T = any>(key: string, _default?: T) => {
  try {
    return window?.localStorage?.getItem(key)
  } catch {
    return _default
  }
}
